<template>
  <div id="navbar">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#">
        <img src="static/logo.png"  />
        {{this.$title_application }}
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <font-awesome-icon icon="user" />
              <em v-text="username"></em>
            </template>
            <b-dropdown-item href="#" @click="$bvModal.show('modal-profile')">Perfil</b-dropdown-item>
            <b-dropdown-item href="#" @click="$bvModal.show('modal-password')">Cambiar Contraseña</b-dropdown-item>
            <b-dropdown-item href="#" @click="logoutUser">Salir</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      username: this.$store.getters.username
    };
  },
  methods: {
    logoutUser() {
      this.$store.dispatch("logoutUser");
      this.$router.push("/login");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/layouts/Navbar.vue